const initialState = {
    code: '',
    timer_time: 0,
    disabledBtn: true,
    isLoading: false,
    btnClass: 'disable-btn', 
};
const verification = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_VERIFICATION':
           return {...state, [action.name]: action.value};
        case 'CHANGE_TIMER_TIME_PAGE_VERIFICATION':
            return {...state, timer_time: action.timer_time};
        case 'CHANGE_DISABLED_BTN_PAGE_VERIFICATION':
            return {...state, disabledBtn: action.disabledBtn};
        case 'CHANGE_LOADER_PAGE_VERIFICATION':
            return {...state, isLoading: action.isLoading};
        case 'CHANGE_BTN_CLASS_PAGE_VERIFICATION':
           return {...state, btnClass: action.className};
        default:
            return state;
    }
};

export default verification;
